module.exports = __webpack_public_path__ + "static/media/preview.844772d7.png";